// Trigger a file download from an axios blob response. Keeps the
// "download a CSV" flow consistent across the app.
export const downloadBlob = (blob, filename) => {
  if (!blob) return
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
